import { FullScreenSpinner, Spinner } from 'components/Elements';
import storage from 'utils/storage';
import { initReactQueryAuth } from 'react-query-auth';
import { getUser } from 'features/auth';
import Cookies from 'js-cookie';
import { parseDeepLink, generateDeepLink } from 'react-deep-link';
import { GATEKEEPER_URL } from 'config';

const token = Cookies.get('token');

const parsedDeepLink = parseDeepLink(
  new URLSearchParams(window.location.search)
);

const token__inParams = parsedDeepLink.state?.token;

export async function handleUserResponse(data) {
  const { user } = data;

  Cookies.set('token', user.token);
  return user;
}

async function loadUser() {
  if (token__inParams) {
    Cookies.set('token', token__inParams);
    const { user } = await getUser();
    return user;
  } else if (token) {
    const { user } = await getUser();
    return user;
  }
  return null;
}

async function logoutFn() {
  Cookies.remove('token');

  const url = generateDeepLink({
    baseUrl: GATEKEEPER_URL,
    route: '/auth/login',
    state: {
      app: 'finance',
      redirectPath: '/app',
    },
  });

  window.location.href = url;
}

const authConfig = {
  loadUser,
  logoutFn,
  LoaderComponent() {
    return (
      <div>
        <FullScreenSpinner />
      </div>
    );
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth(authConfig);
